(function () {
  'use strict';
  angular
    .module('RPOL_RisparmioBuoniAPP', [
      'risparmioBuoni'
    ]);

  angular
    .module('appRPOL_RisparmioBuoniAPP', [])
    .config(['$provide', '$httpProvider', exceptionConfig])
    .run(
      ['$rootScope', '$window', function ($rootScope, $window) {
        $rootScope.UrlBase = $window.location.host;
        $rootScope.UrlProtocol = $window.location.protocol + '//';
      }]);

  /**
 * exception config
 * 
 * @param $provide
 * @param $httpProvider
 */
  function exceptionConfig($provide, $httpProvider) {
    $provide.decorator('$exceptionHandler', ['$delegate', '$log', '$injector',
      function extendExceptionHandler($delegate, $log, $injector) {
        return function (exception, cause) {
          $log.log('Start extendExceptionHandler');
          $delegate(exception, cause);
          $injector.get('$rootScope').showGenericErrorPage = true;
          hide_pageloader();
        };
      }]);
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
  }

})();

/**
 * download progressione
 */
function downloadProgressione(elem) {
  var id = $(elem).attr("buonoid");
  $("#downloadprogressioni").attr("buonoid", id).click();
  return false;
}

/**
 * execute acquista action
 */
function acquista(event) {
  event.preventDefault();
  var elem = event.target;

  // get data
  var href = $(elem).attr("href");
  var codiceprodotto = $(elem).attr("buonoid");
  var taglioselezionato = $(elem).attr("buonoimporto");
  var nomeprodotto = $(elem).attr("buononome");
  var tipoprodotto = $(elem).attr("buonotipo");
  var vincolo = $(elem).attr("buonovincolo");
  var nl = $(elem).attr("buononl");
  var target = $(elem).attr("target") || '_blank';

  // add cookies
  if (typeof Cookies !== 'undefined') {

    Cookies.set("ab_codice", codiceprodotto, {
      domain: ".poste.it"
    });
    Cookies.set("ab_taglio", taglioselezionato, {
      domain: ".poste.it"
    });
    Cookies.set("ab_nome", nomeprodotto, {
      domain: ".poste.it"
    });

    if (tipoprodotto) {
      Cookies.set("ab_tipo", tipoprodotto, {
        domain: ".poste.it"
      });
    } else {
      Cookies.remove("ab_tipo", {
        domain: ".poste.it"
      });
    }
    if (vincolo) {
      Cookies.set("ab_vincolo", vincolo, {
        domain: ".poste.it"
      });
    } else {
      Cookies.remove("ab_vincolo", {
        domain: ".poste.it"
      });
    }
    if (nl) {
      Cookies.set("ab_nl", nl, {
        domain: ".poste.it"
      });
    } else {
      Cookies.remove("ab_nl", {
        domain: ".poste.it"
      });
    }
  }
  // go to URL with params
  window.open(href, target)
}